let loaded = false;

// gtag.js for the primary GA4 id is already loaded in index.html.
// Only inject a tag if a DIFFERENT id is configured; otherwise reuse the existing one.
export function initGA(id) {
  if (!id || loaded || typeof window === "undefined") return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  const already = document.querySelector(
    `script[src*="googletagmanager.com/gtag/js?id=${id}"]`
  );
  if (!already) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);
    window.gtag("js", new Date());
    window.gtag("config", id);
  }
}

export function trackEvent(name, params = {}) {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", name, params);
  }
}

export function trackPageView(path, id) {
  if (typeof window !== "undefined" && window.gtag && id) {
    window.gtag("config", id, { page_path: path });
  }
}
